// angular import
import { Component, OnInit, output } from '@angular/core';

// project import

import { NavLeftComponent } from './nav-left/nav-left.component';
import { NavRightComponent } from './nav-right/nav-right.component';
import { Api } from 'src/app/services/api';
import { E } from '@angular/material/error-options.d-CGdTZUYk';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-bar',
  imports: [NavLeftComponent, NavRightComponent],
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
  // public props
  NavCollapse = output();
  NavCollapsedMob = output();

  navCollapsed: boolean;
  windowWidth: number;
  navCollapsedMob: boolean;
upcomminvac: number = 0;
muestro = false
isAdminOnly:any;
  // Constructor
  constructor(private apiservice: Api, private router: Router) {
    this.windowWidth = window.innerWidth;
    this.navCollapsedMob = false;

  }

ngOnInit(): void {
}

ngAfterViewInit(){
  // Vacaciones Cron vacaciones_run, vacaciones_cron
  this.apiservice.runVacationDailyProcess().subscribe({
    next:(vac_process)=>{
      console.log('vac_check_once', vac_process);
    }
  });

  let rol = localStorage.getItem('rol');
  let suc_base = localStorage.getItem('suscursal_base');
this.muestro = this.apiservice.roleListAdmin.includes(rol);
this.isAdminOnly = this.apiservice.roleJustAdmin.includes(rol);
let filtro = this.isAdminOnly ? ` AND sucursal = ${suc_base}` : ``;
    console.log('heder loaded');
    let q=`SELECT *
FROM timeoff_history tf
WHERE tf.status = 'Aprobado'
${filtro}
  AND tf.ack = 0
  AND DATE_ADD(
        tf.dateOff,
        INTERVAL
          CASE
            WHEN DATE_ADD(tf.dateOff, INTERVAL YEAR(CURDATE()) - YEAR(tf.dateOff) YEAR) >= CURDATE()
            THEN YEAR(CURDATE()) - YEAR(tf.dateOff)
            ELSE YEAR(CURDATE()) - YEAR(tf.dateOff) + 1
          END YEAR
      )
      <= CURDATE() + INTERVAL 30 DAY`;
      setTimeout(() => {
  this.apiservice.rawquery('vacationsalert', btoa(q)).subscribe({
    next:(vac)=>{
      this.upcomminvac = vac.length;
      // console.log(vac.length);
    },
    error:(e)=>{
      console.log('erro0r ', e.error)
    }
  });
        }, 500);
}
  // public method
  navCollapse() {
    if (this.windowWidth >= 1025) {
      this.navCollapsed = !this.navCollapsed;
      this.NavCollapse.emit();
    }
  }

  navCollapseMob() {
    if (this.windowWidth < 1025) {
      this.NavCollapsedMob.emit();
    }
  }

  goto(){
if(this.isAdminOnly){
        this.router.navigate(['/time_off_admin'], {
  queryParams: { tab: '2' }
});
}else{
     this.router.navigate(['/time_off'], {
  queryParams: { tab: '2' }
});
}



  }
}
